import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { grantConsent, revokeConsent, track } from "@/lib/analytics";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const prev = localStorage.getItem("risco_cookie_consent");
    if (!prev) {
      setVisible(true);
    }
    // Delegazione click globale per tracciare telefono e WhatsApp (una sola volta).
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (href.startsWith("tel:")) {
        track("click_telefono", { numero: href.replace("tel:", "") });
      } else if (/(^https?:\/\/(wa\.me|api\.whatsapp\.com|chat\.whatsapp\.com)\/|whatsapp)/i.test(href)) {
        track("click_whatsapp", { url: href });
      }
    };
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);

  const accept = () => {
    localStorage.setItem("risco_cookie_consent", "accepted");
    grantConsent();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("risco_cookie_consent", "declined");
    revokeConsent();
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-risco-border shadow-2xl"
      data-testid="cookie-banner"
    >
      <div className="container-x py-4 md:py-5 flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="text-sm text-stone-700 flex-1">
          <strong className="text-risco-ink">Cookie & Privacy.</strong> Utilizziamo cookie tecnici necessari al funzionamento e, previo consenso,
          cookie analitici (Google Analytics 4) e di profilazione per migliorare l'esperienza. Leggi la{" "}
          <Link to="/privacy" className="text-risco-accent underline">Privacy Policy</Link>.
        </div>
        <div className="flex gap-2">
          <button
            onClick={decline}
            data-testid="cookie-decline"
            className="px-4 py-2 rounded-md border border-stone-300 text-risco-ink text-sm hover:bg-risco-alt"
          >
            Rifiuta
          </button>
          <button
            onClick={accept}
            data-testid="cookie-accept"
            className="px-4 py-2 rounded-md bg-risco-accent text-white text-sm font-semibold hover:bg-risco-accent-dark"
          >
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
}
